import { flexRender,
    getCoreRowModel,
    useReactTable, } from '@tanstack/react-table';
import SDKPositionResultType from '../model/SDKPositionResultType';

const SDKPositionLogResult = (props:{result:SDKPositionResultType[], mounted: string}) => {
    const data: SDKPositionResultType[] = props.result;
    let columns;
    columns = [
        { header: "no", accessorKey: "no" },
        { header: "bundle_id", accessorKey: "bundle_id" },
        { header: "device_id", accessorKey: "device_id" },
        { header: "cluster_id", accessorKey: "cluster_id" },
        { header: "x", accessorKey: "x" },
        { header: "y", accessorKey: "y" },
        { header: "h", accessorKey: "h" },
        { header: "r", accessorKey: "r" },
        { header: "count", accessorKey: "count" },
        { header: "nearest", accessorKey: "nearest" },
        { header: "detected", accessorKey: "detected" },
        { header: "arrived", accessorKey: "arrived" }
    ];
    
      
    const table = useReactTable({columns, data, getCoreRowModel: getCoreRowModel()})
    return (
        <div>
            <p className='mx-3'>項目の表示・非表示</p>
            <div id='colVisible' className="px-1 mx-3">
                {table.getAllLeafColumns().map(column => {
                return (
                <label className='mx-3'>
                    <input
                    {...{
                        type: 'checkbox',
                        checked: column.getIsVisible(),
                        onChange: column.getToggleVisibilityHandler(),
                    }}
                    />{' '}
                    {column.id}
                </label>
                )
                })}
            </div>
            <div className='dataScroll'>
                <table>
                    <thead>
                    {table.getHeaderGroups().map((headerGroup) => (
                        <tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                            <th key={header.id}>
                            {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                            </th>
                        ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.map((row) => (
                            <tr key={row.id}>
                            {row.getVisibleCells().map((cell) => (
                                <td key={cell.id}>{flexRender(cell.column.columnDef.cell, cell.getContext())}</td>
                            ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default SDKPositionLogResult